import { render, staticRenderFns } from "./KnowledgeSidebar.vue?vue&type=template&id=78d6a779&scoped=true"
import script from "./KnowledgeSidebar.vue?vue&type=script&lang=js"
export * from "./KnowledgeSidebar.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeSidebar.vue?vue&type=style&index=0&id=78d6a779&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d6a779",
  null
  
)

export default component.exports